import { useEffect, DependencyList, EffectCallback } from 'react'
import { useABConfig } from '../context/ab-config-context'

/**
 * Custom hook that wraps useEffect to ensure the effect only runs after
 * the AB configuration has been successfully initialized (or has failed).
 * This prevents components from interacting with a null AB Configuration before the
 * networking phase completes.
 *
 * @param effect - The effect callback to run (same as useEffect)
 * @param deps - Dependencies array (same as useEffect)
 */
export const useABEffect = (effect: EffectCallback, deps: DependencyList = []) => {
    const { isInitialized } = useABConfig()

    useEffect(() => {
        if (!isInitialized) {
            // Still fetching initial config, skip effect
            return
        }

        // Context is ready (either loaded or error), run the effect
        return effect()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isInitialized, ...deps])
}
